import { FC } from 'react';

import classNames from 'classnames';
import { getYear } from 'date-fns';

import { IconButton, If, Then } from '@hsp/react-component-library';
import { formatDate, isDefined } from '@hsp/utilities';

import { s } from 'utilities/strings';

import { DatePickerHeaderProps } from './types/header.props';

import cssClasses from './header.module.scss';

const DatePickerHeader: FC<DatePickerHeaderProps> = ({
  date,
  decreaseMonth,
  decreaseYear,
  increaseMonth,
  increaseYear,
  maxDate,
  minDate,
  nextMonthButtonDisabled,
  nextYearButtonDisabled,
  prevMonthButtonDisabled,
  prevYearButtonDisabled,
  showFullMonthYearPicker = true,
  showMonthYearPicker = false,
  showYearPicker = false,
  yearItemNumber = 12,
}) => {
  const year = getYear(date);
  const endPeriod = Math.ceil(year / yearItemNumber) * yearItemNumber;
  const startPeriod = endPeriod - (yearItemNumber - 1);

  return (
    <div className={cssClasses.datePickerHeader}>
      <IconButton
        color="primary"
        data-tooltip-content={s(['Site.Previous', 'Site.Year'])}
        data-tooltip-id="global-tool-tip"
        data-tooltip-place="bottom"
        disabled={prevYearButtonDisabled || (showYearPicker && isDefined(minDate) && startPeriod <= getYear(minDate))}
        icon={['fas', 'angle-double-left']}
        onClick={decreaseYear}
        outline
        size="sm"
        type="button"
      />
      <If condition={showFullMonthYearPicker}>
        <Then>
          {() => {
            return (
              <IconButton
                color="primary"
                data-tooltip-content={s(['Site.Previous', 'Site.Month'])}
                data-tooltip-id="global-tool-tip"
                data-tooltip-place="bottom"
                disabled={prevMonthButtonDisabled}
                icon={['fas', 'angle-left']}
                onClick={decreaseMonth}
                outline
                size="sm"
                type="button"
              />
            );
          }}
        </Then>
      </If>
      <If condition={showFullMonthYearPicker}>
        <Then>
          {() => {
            return (
              <div className={cssClasses.datePickerHeaderDate}>
                {`${formatDate(date, 'MMMM')} ${formatDate(date, 'yyyy')}`}
              </div>
            );
          }}
        </Then>
      </If>
      <If condition={showMonthYearPicker}>
        <Then>
          {() => {
            return <div className={cssClasses.datePickerHeaderDate}>{formatDate(date, 'yyyy')}</div>;
          }}
        </Then>
      </If>
      <If condition={showYearPicker}>
        <Then>
          {() => {
            return (
              <div
                className={classNames(cssClasses.datePickerHeaderDate, 'mx-3')}>{`${startPeriod} - ${endPeriod}`}</div>
            );
          }}
        </Then>
      </If>
      <If condition={showFullMonthYearPicker}>
        <Then>
          {() => {
            return (
              <IconButton
                color="primary"
                data-tooltip-content={s(['Site.Next', 'Site.Month'])}
                data-tooltip-id="global-tool-tip"
                data-tooltip-place="bottom"
                disabled={nextMonthButtonDisabled}
                icon={['fas', 'angle-right']}
                onClick={increaseMonth}
                outline
                size="sm"
                type="button"
              />
            );
          }}
        </Then>
      </If>
      <IconButton
        color="primary"
        data-tooltip-content={s(['Site.Next', 'Site.Year'])}
        data-tooltip-id="global-tool-tip"
        data-tooltip-place="bottom"
        disabled={nextYearButtonDisabled || (showYearPicker && isDefined(maxDate) && endPeriod >= getYear(maxDate))}
        icon={['fas', 'angle-double-right']}
        onClick={increaseYear}
        outline
        size="sm"
        type="button"
      />
    </div>
  );
};

export default DatePickerHeader;
